import { FUND_PAGES } from './fundPages'
import type { PortfolioSlug } from './fundConfig'

// Paolo 2026-11-03: the FOF home page shows the same tab bar as a fund page;
// a fund tab there (P&L, Risk, …) opens that tab on the last fund visited.
// Each fund is its own subdomain, so the memory is a cookie on the parent
// domain (host-only on localhost), not localStorage (per-origin).
export const LAST_FUND_COOKIE = 'sw_last_fund'
const PARENT_DOMAIN = 'buxushedgefund.com'

function cookieDomain(hostname: string): string {
  return hostname === PARENT_DOMAIN || hostname.endsWith(`.${PARENT_DOMAIN}`) ? `; domain=.${PARENT_DOMAIN}` : ''
}

/** Remember a fund page (never the otp overlay) as the last fund visited. */
export function rememberLastFund(slug: PortfolioSlug, hostname: string, doc: Pick<Document, 'cookie'> = document): void {
  if (FUND_PAGES[slug]?.kind !== 'fund') return
  try {
    doc.cookie = `${LAST_FUND_COOKIE}=${slug}; path=/; max-age=31536000; SameSite=Lax${cookieDomain(hostname)}`
  } catch { /* cookies blocked: Home falls back to BGA */ }
}

/** document.cookie, or '' where cookies can't be read (blocked, or no URL in tests). */
export function readCookies(doc: Pick<Document, 'cookie'> = document): string {
  try { return doc.cookie } catch { return '' }
}

/** The last fund visited, if the caller may still see it; else 'bga'. */
export function readLastFund(cookie: string, visible: ReadonlyArray<PortfolioSlug>): PortfolioSlug {
  const raw = cookie.split(';').map(c => c.trim()).find(c => c.startsWith(`${LAST_FUND_COOKIE}=`))
  const slug = raw?.slice(LAST_FUND_COOKIE.length + 1) as PortfolioSlug | undefined
  return slug && visible.includes(slug) && FUND_PAGES[slug]?.kind === 'fund' ? slug : 'bga'
}
